"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _gatsbyPluginImage = require("gatsby-plugin-image");
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
const _excluded = ["image", "alt", "objectFit", "imgStyle"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const GatsbyImage = props => {
  var _image$gatsbyImage, _image$localFile;
  const {
      image,
      alt = "",
      objectFit,
      imgStyle
    } = props,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  if (image !== null && image !== void 0 && image.svg) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _htmlReactParser.default)(image.svg));
  }
  const id = (image === null || image === void 0 ? void 0 : image.id) || (image === null || image === void 0 ? void 0 : image.sourceUrl) || (image === null || image === void 0 || (_image$gatsbyImage = image.gatsbyImage) === null || _image$gatsbyImage === void 0 || (_image$gatsbyImage = _image$gatsbyImage.images) === null || _image$gatsbyImage === void 0 || (_image$gatsbyImage = _image$gatsbyImage.fallback) === null || _image$gatsbyImage === void 0 ? void 0 : _image$gatsbyImage.src) || (image === null || image === void 0 || (_image$localFile = image.localFile) === null || _image$localFile === void 0 || (_image$localFile = _image$localFile.childImageSharp) === null || _image$localFile === void 0 || (_image$localFile = _image$localFile.gatsbyImageData) === null || _image$localFile === void 0 || (_image$localFile = _image$localFile.images) === null || _image$localFile === void 0 || (_image$localFile = _image$localFile.fallback) === null || _image$localFile === void 0 ? void 0 : _image$localFile.src);
  const component = (0, _react.useMemo)(() => {
    if (image !== null && image !== void 0 && image.localFile) {
      return /*#__PURE__*/_react.default.createElement(_gatsbyPluginImage.GatsbyImage, (0, _extends2.default)({}, rest, {
        objectFit: objectFit,
        imgStyle: imgStyle,
        image: (0, _gatsbyPluginImage.getImage)(image.localFile),
        alt: alt
      }));
    }
    if (image !== null && image !== void 0 && image.gatsbyImage) {
      return /*#__PURE__*/_react.default.createElement(_gatsbyPluginImage.GatsbyImage, (0, _extends2.default)({}, rest, {
        objectFit: objectFit,
        imgStyle: imgStyle,
        image: (0, _gatsbyPluginImage.getImage)(image.gatsbyImage),
        alt: alt
      }));
    } else if (image !== null && image !== void 0 && image.sourceUrl) {
      return /*#__PURE__*/_react.default.createElement(_gatsbyPluginImage.GatsbyImage, (0, _extends2.default)({}, rest, {
        objectFit: objectFit,
        imgStyle: imgStyle,
        image: {
          height: image === null || image === void 0 ? void 0 : image.height,
          width: image === null || image === void 0 ? void 0 : image.width,
          images: {
            fallback: {
              sizes: (image === null || image === void 0 ? void 0 : image.sizes) || "",
              srcSet: (image === null || image === void 0 ? void 0 : image.srcSet) || "",
              src: image.sourceUrl
            },
            sources: [{
              sizes: (image === null || image === void 0 ? void 0 : image.sizes) || "",
              srcSet: (image === null || image === void 0 ? void 0 : image.srcSet) || "",
              type: (image === null || image === void 0 ? void 0 : image.mediaType) || "image"
            }]
          },
          layout: "constrained",
          placeholder: {
            fallback: ""
          }
        },
        alt: alt
      }));
    } else {
      return null;
    }
  }, [id, objectFit, imgStyle]);
  return component;
};
var _default = exports.default = GatsbyImage;